import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject, EMPTY } from 'rxjs';

@Injectable()
export class BlanketAddProductSliderModelService {
  public addBlanketProductSlider: BehaviorSubject<boolean>;
  public Blanketsidenav: MatSidenav;
  private activeSliderValue: string;
  BlanketSliderCloseRqt: Subject<boolean>;
  BlanketModelData: BehaviorSubject<any>;
  public shipToAccount: number;

  constructor() {
    this.addBlanketProductSlider = new BehaviorSubject(false);
    this.BlanketModelData = new BehaviorSubject(EMPTY);
    this.BlanketSliderCloseRqt = new Subject();
  }

  activeSlider(value: string) {
    this.activeSliderValue = value;

    if (value === 'AddBlanketProductSlider') {
      this.addBlanketProductSlider.next(true);
      this.BlanketModelData.next(EMPTY);
      this.Blanketsidenav.toggle();
    }
  }

  public SetBlanketSideNav(BlanketSideNavObj: MatSidenav) {
    this.Blanketsidenav = BlanketSideNavObj;
  }

  public BlanketClose() {
    this.BlanketModelData.next(EMPTY);
    this.addBlanketProductSlider.next(false);
    this.Blanketsidenav.close();
  }

  public setData<T>(obj: T) {
    this.BlanketModelData.next(obj);
  }

  public setRequestData<T>(obj: T) {
    this.BlanketModelData.next(obj);
  }
}
